import React, { Component } from 'react';
import { Field } from 'redux-form';
import ReactDOM from 'react-dom';
import Moment from 'moment';

import FormInputCorrectMessage from './form-input-correct-message';
import FormInputErrorMessage from './form-input-error-message';
import Dropdown from './dropdown';

import { getDropdownDefaultOption, setErrorWidth } from '../../utilities/form-helpers';
import TranslatedCopy from '../../intl/translated-copy';


class FormInputExpiry extends Component {
  static defaultProps = {
    isDisabled: false,
    isRequired: false,
    shouldSetErrorWidth: false,
  }
  constructor() {
    super();

    /** -
     * @type {Object}
     * @prop {Number} errorWidth - max width of error message container
     * @prop {Boolean} hasBeenFocused - user has focused on expiry date
     * @prop {String} selectedMonth - month entered
     * @prop {String} selectedYear - year entered
     */
    this.state = {
      errorWidth: null,
      hasBeenFocused: false,
      selectedMonth: null,
      selectedYear: null,
      placeholderYear: null,
      placeholderMonth: null,
    };

    this.monthOptions = this.getListMonths();
    this.yearOptions = this.getListYears();
  }

  componentWillMount() {
    const { input: { value } } = this.props;

    if (value) {
      this.handleBlur();

      const selectedDate = value.split('-');
      const selectedMonth = selectedDate[1];
      const selectedYear = selectedDate[0];

      this.setState({
        defaultMonthOption: getDropdownDefaultOption(this.monthOptions, selectedMonth),
        defaultYearOption: getDropdownDefaultOption(this.yearOptions, selectedYear),
        selectedMonth: selectedMonth,
        selectedYear: selectedYear,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      meta: { error, touched },
    } = this.props;

    const isError = error && touched;

    if (!isError && nextProps.meta.error && nextProps.meta.touched) {
      // Dispara métrica de error
    }
  }

  componentDidUpdate() {
    const {
      input: { value },
      meta: { pristine },
      shouldSetErrorWidth,
    } = this.props;
    const {
      errorWidth,
      selectedMonth,
      selectedYear,
    } = this.state;

    // When all date fields are entered, trigger change event
    const newDate = `${selectedYear}-${selectedMonth}`;
    const allFieldsSelected = selectedMonth && selectedYear;

    if (allFieldsSelected && newDate !== value && (!pristine || newDate.length === 7)) {
      this.handleDateChange(newDate);
    }

    // Set error width (prevents error message being truncated)
    if (this.formInputErrorDOM && shouldSetErrorWidth) {
      const newErrorWidth = setErrorWidth(this.formInputErrorDOM.getBoundingClientRect().left);

      if (newErrorWidth !== errorWidth) {
        this.setState({
          errorWidth: newErrorWidth,
        });
      }
    }
  }

  render() {
    const {
      isRequired,
      input: { value, name },
      labelCopyID,
      meta: {
        error,
        touched,
        valid,
      },
    } = this.props;

    const {
      errorWidth,
      selectedMonth,
      selectedYear,
    } = this.state;

    const isError = error && touched;
    const isValid = valid && value && touched && (selectedMonth && selectedYear);

    return (
      <div className='FormInput-wrapper FormInputExpiry FormInput'>
        <label
          className='FormInput-label'
          htmlFor=''>
          <TranslatedCopy copyID={ labelCopyID } className='FormInput-label--isRequired' />
          { !isRequired ?
            <span className='FormInput-labelOptional'> (<TranslatedCopy copyID='APP_OPTIONAL' />)</span> : null }
        </label>

        <div>
          <div className='FormInputExpiry-wrapper'>
            <Field
              name='expMonth'
              className='FormInputExpiry-dropdown'
              component={ Dropdown }
              isRequired={ isRequired }
              options={ this.monthOptions }
              handleBlur={ (val) => this.handleBlur(val) }
              onSelect={ (i, val) => this.handleMonthChange(i, val) }
              handler={ this.handler } />
            <Field
              name='expYear'
              className='FormInputExpiry-dropdown'
              component={ Dropdown }
              isRequired={ isRequired }
              options={ this.yearOptions }
              handleBlur={ (val) => this.handleBlur(val) }
              onSelect={ (i, val) => this.handleYearChange(i, val) }
              handler={ this.handler } />
          </div>
          { isError ?
            <FormInputErrorMessage
              name={ name }
              error={ error }
              errorWidth={ errorWidth }
              ref={ (c) => this.formInputErrorDOM = ReactDOM.findDOMNode(c) } /> : null }
        </div>
        { isValid ? <FormInputCorrectMessage value={ value } /> : null }
      </div>
    );
  }

  /**
   * @param {SyntheticEvent} e
   */
  handleBlur(newValue) {
    const { input: { onBlur } } = this.props;
    const {
      hasBeenFocused,
      selectedMonth,
      selectedYear,
    } = this.state;

    if (selectedMonth && selectedYear) {
      onBlur(newValue);
    } else {
      onBlur();
    }

    if (!hasBeenFocused) {
      this.setState({
        hasBeenFocused: true,
      });
    }
  }

  /**
   * @param {String} newDate - YYYY-MM
   */
  handleDateChange(newDate) {
    this.handleBlur(newDate);
  }

  /**
   * @param {Number} i - Selected month index
   * @param {Number} val - Selected month
   */
  handleMonthChange(i, val) {
    const { selectedYear } = this.state;

    this.setState({
      selectedMonth: val,
    });

    this.handleDateChange(`${selectedYear}-${val}`);
  }

  /**
   * @param {Number} i - Selected month index
   * @param {Number} val - Selected month
   */
  handleYearChange(i, val) {
    const { selectedMonth } = this.state;

    this.setState({
      selectedYear: val,
    });

    this.handleDateChange(`${val}-${selectedMonth}`);
  }

  getListMonths() {
    const arrMonths = [];

    Moment.monthsShort().forEach((element, i) => {
      const numMonth = i < 9 ?
        `0${(i + 1).toString()}` :
        (i + 1).toString();

      arrMonths.push({
        name: `${numMonth} - ${element}`,
        value: `${numMonth}`,
        monthIndex: (i + 1),
      });
    });
    return arrMonths;
  }

  getListYears() {
    const arrYears = [];

    // Number of months to render
    const yearsToRender = 12;

    let year = null;

    for (let i = 0; i < yearsToRender; i++) {
      year = Moment().add(i, 'years').format('YYYY');

      arrYears.push({
        name: `${year}`,
        value: `${year}`,
      });
    }

    return arrYears;
  }
}

export default FormInputExpiry;
